//
//
//
//
//
//
//
//
//
//
//
import FetchError from "../services/api/FetchError";
export default {
  name: "FetchError",
  props: {
    error: {
      required: true,
      type: FetchError
    }
  }
};